

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Button, Typography, Grid, MenuItem, IconButton, Autocomplete, TextField, TableRow, TableCell } from "@mui/material";
import { TableContainer, Table, TableHead, TableBody } from "@mui/material";
import { Breadcrumb } from "../../reusableComponent/Reusables";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionIcon from "@mui/icons-material/Description";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import productMasterService from "../../../services/masters/productMaster.Service";
import customerProductService from "../../../services/masters/customerProductMaster.Service.js";
import accountManagerSeervice from "../../../services/masters/accountManagerMaster.Service.js";
import customerMasterService from "../../../services/masters/customerMaster.Service.js";
import uomMasterService from "../../../services/masters/uomMaster.Service.js";
import customerPoService from "../../../services/customerPo.Service.js";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import sales_order from '../../../services/sales_order';

// ── Styles (PlantAdd pattern) ─────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Segoe UI', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",

  border: "1px solid #E2E8F0",
  overflow: "hidden",
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "22px 24px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const sectionDividerSx = {
  fontSize: "11px",
  fontWeight: 700,
  color: "#1C3A5E",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  mb: 1.5,
  pb: 0.75,
  borderBottom: "2px solid #E2E8F0",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F0F0F0" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F0F0",
  },
};

const datePickerSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
  },
};

const tableHeadSx = {
  background: "#1C3A5E",
  "& th": {
    color: "#fff",
    fontSize: "11px",
    fontWeight: 600,
    padding: "10px 10px",
    whiteSpace: "nowrap",
    borderBottom: "none",
  },
};

const tableCellInputSx = {
  border: "none",
  background: "transparent",
  fontSize: "12px",
  width: "100%",
  padding: "2px 4px",
  outline: "none",
  color: "#1A202C",
  fontFamily: "'Segoe UI', Arial, sans-serif",
};

const formFooterSx = {
  padding: "16px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "38px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#388E3C" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "38px",
  background: "#E53E3E",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": { background: "#C53030" },
};

// ─────────────────────────────────────────────────────────────────────────────

const emptyRow = () => ({
  srno: "", prod_id: "", prod_code: "", prod_description: "",
  plan_qty: "", qty_kg: "", Del_qty: "", bal_qty: "",
  cylinder_no: "", max_holding: "", curr_hold: ""
});

const Addsalesorder = () => {
  const location = useLocation();
  const salesOrderData = location.state;
  const navigate = useNavigate();
  const { handleSubmit } = useForm();

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

  const editData = location.state;

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [Product, setProduct] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [account_manager, setAccountManager] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [cpd, setCpd] = useState([]);
  const [uom, setUOM] = useState([]);
  const [schedule_entry, setScheduleEntry] = useState([]);
  const [salesOrder, SetSalesOrder] = useState([]);
  const [filteredCustomersWithPo, setFilteredCustomersWithPo] = useState([]);
  const [filteredPoList, setFilteredPoList] = useState([]);
  const [filteredSalesOfficers, setFilteredSalesOfficers] = useState([]);
  const [salesorderDetails, setSalesorderDetails] = useState([emptyRow()]);
  const [saving, setSaving] = useState(false);
const submitLock = useRef(false);

  const [data, setData] = useState({
    sales_order_id: editData?.sales_order_id || null,
    so_no: editData?.so_no || "",
    so_date: editData?.so_date
      ? dayjs(editData.so_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    po_no: editData?.po_no || "",
    po_date: editData?.po_date
      ? dayjs(editData.po_date).format("DD/MM/YYYY")
      : dayjs().format("DD/MM/YYYY"),
    customer_name: editData?.customer_name || "",
    sales_officer_id: editData?.sales_officer_id || null,
    sales_officer_name: editData?.sales_officer_name || "",
    fin_year: editData?.fin_year || "",
  });

  // ── Fetch master data ────────────────────────────────────────────────────
  useEffect(() => {
  async function fetchData() {
    try {
      setLoading(true);
      const [ProductData, cylinderData, account_managerData, customerData,
        cpdData, uomData, schedule_entryData, salesOrderList] = await Promise.all([
        productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
        cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
        accountManagerSeervice.getAccountManagerList({ page: 0, size: 999, searchKey: "" }),
        customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
        customerProductService.getCpdList({ page: 0, size: 999, searchKey: "" }),
        uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
        customerPoService.getScheduleEntryList({ page: 0, size: 999, searchKey: "" }),
        sales_order.getsalesorder({ page: 0, size: 5, searchKey: "" }), // ✅ SO list
      ]);

      setProduct(ProductData);
      setCylinder(cylinderData);
      setAccountManager(account_managerData);
      setCustomer(customerData);
      setCpd(cpdData);
      setUOM(uomData);
      setScheduleEntry(schedule_entryData);

      const customersWithPo = [...new Map(
        schedule_entryData
          .filter(e => e.po_no && e.po_no.trim() !== '')
          .map(item => [item.customer_name, item])
      ).values()];
      setFilteredCustomersWithPo(customersWithPo);

      if (editData?.customer_name) {
        const filteredEntries = schedule_entryData.filter(
          e => e.customer_name === editData.customer_name && e.po_no && e.po_no.trim() !== ''
        );
        const uniqueOfficers = [...new Map(filteredEntries.map(item =>
          [item.sales_officer_id, { sales_officer_id: item.sales_officer_id, sales_officer_name: item.sales_officer_name }]
        )).values()];
        setFilteredSalesOfficers(uniqueOfficers);
        setFilteredPoList(filteredEntries);
      }

      // ✅ SO No Generation
      if (!editData?.sales_order_id) {
        console.log("salesOrderList:", salesOrderList);
        console.log("All so_nos:", salesOrderList?.map(d => d.so_no));

        const yr = dayjs();
        const finYear = yr.month() >= 3
          ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
          : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

        const sameYearEntries = salesOrderList?.filter(d => d.so_no?.includes(finYear)) ?? [];
        const lastSoNo = sameYearEntries?.[0]?.so_no ?? "";
        console.log("lastSoNo:", lastSoNo);

        const parts = String(lastSoNo).split("/");
        const lastSeq = parseInt(parts[parts.length - 1]) || 0;
        const nextSeq = lastSeq + 1;

        const formattedSoNo = `SO/${finYear}/${String(nextSeq).padStart(4, "0")}`;
        console.log("Generated SO No:", formattedSoNo);

        setData(prev => ({
          ...prev,
          so_no: formattedSoNo,
          fin_year: finYear,
        }));
      }

    } catch (err) {
      console.error("Data fetching failed", err);
    } finally {
      setLoading(false);
    }
  }
  fetchData();
}, []);

  // ── Reset rows ────────────────────────────────────────────────────────────
  const resetSalesOrderDetails = useCallback(() => {
    setSalesorderDetails([emptyRow()]);
  }, []);

  // ── Fetch SO table data on customer+PO change ─────────────────────────────
  useEffect(() => {
    async function fetchSalesOrderData() {
      if (!data.customer_name || !data.po_no) { resetSalesOrderDetails(); return; }
      try {
        const selectedEntry = schedule_entry.find(
          e => e.customer_name === data.customer_name && e.po_no === data.po_no
        );
        if (selectedEntry) {
          const soData = await sales_order.getSoTabledata(selectedEntry.customer_id, data.po_no);
          SetSalesOrder(soData || []);
          if (soData?.length > 0) {
            setSalesorderDetails(soData.map((item, i) => ({
              srno: i + 1,
              prod_id: item.prod_id || "",
              prod_code: item.prod_code || "",
              prod_description: item.prod_description || "",
              cylinder_no: item.cylinder_no || "",
              qty_kg: item.qty_kg || "",
              Del_qty: item.Del_qty || "",
              bal_qty: item.bal_qty || "",
              plan_qty: "",
              max_holding: item.max_holding || "",
              curr_hold: item.curr_hold || ""
            })));
          } else {
            resetSalesOrderDetails();
          }
        } else {
          resetSalesOrderDetails();
        }
      } catch (err) {
        console.error("Failed to fetch SO data:", err);
        resetSalesOrderDetails();
      }
    }
    fetchSalesOrderData();
  }, [data.customer_name, data.po_no, schedule_entry, resetSalesOrderDetails]);

  // ── Pre-fill on edit ──────────────────────────────────────────────────────
  useEffect(() => {
    if (salesOrderData?.table_details) {
      try {
        const parsed = JSON.parse(salesOrderData.table_details);
        setSalesorderDetails(parsed.map(item => ({ ...emptyRow(), ...item })));
      } catch { setSalesorderDetails([emptyRow()]); }
    }
  }, [salesOrderData]);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'customer_name') {
      const filteredEntries = schedule_entry.filter(
        e => e.customer_name === value && e.po_no && e.po_no.trim() !== ''
      );
      const uniqueOfficers = [...new Map(filteredEntries.map(item =>
        [item.sales_officer_id, { sales_officer_id: item.sales_officer_id, sales_officer_name: item.sales_officer_name }]
      )).values()];
      setFilteredSalesOfficers(uniqueOfficers);
      setFilteredPoList(filteredEntries);
      setData(prev => ({ ...prev, customer_name: value, sales_officer_id: null, sales_officer_name: '', po_no: '', po_date: '' }));

    } else if (name === 'sales_officer_id') {
      const officer = filteredSalesOfficers.find(o => o.sales_officer_id === value);
      const filteredPOs = schedule_entry.filter(
        e => e.customer_name === data.customer_name && e.sales_officer_id === value && e.po_no && e.po_no.trim() !== ''
      );
      setFilteredPoList(filteredPOs);
      setData(prev => ({
        ...prev,
        sales_officer_id: value,
        sales_officer_name: officer?.sales_officer_name || '',
        po_no: '', po_date: ''
      }));

    } else if (name === 'po_no') {
      const entry = schedule_entry.find(e => e.customer_name === data.customer_name && e.po_no === value);
      setData(prev => ({ ...prev, po_no: value, po_date: entry?.po_date || '' }));

    } else {
      setData(prev => {
        const updated = { ...prev, [name]: value };
        if (name === 'so_date') {
          const m = new Date(value).getMonth();
          const y = new Date(value).getFullYear();
          updated.fin_year = m >= 3 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
        }
        return updated;
      });
    }
  };

  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    setSalesorderDetails(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [name]: value };
      if (name === 'Del_qty') {
        const po = parseFloat(updated[index].qty_kg) || 0;
        const del = parseFloat(value) || 0;
        updated[index].bal_qty = (po - del).toString();
      }
      return updated;
    });
  };

  const handleAddRow = () => setSalesorderDetails(prev => [...prev, emptyRow()]);

  const handleRemoveRow = (index) => setSalesorderDetails(prev => prev.filter((_, i) => i !== index));

  const onSubmit = async () => {
  if (submitLock.current) return;
  submitLock.current = true;
  setSaving(true);
    const currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
    const selectedEntry = schedule_entry.find(
      e => e.customer_name === data.customer_name && e.po_no === data.po_no
    );
  if (!selectedEntry) {
  setSuccessMessage("Error: Cannot find customer information");
  submitLock.current = false;
  setSaving(false);
  return;
}

const ids = salesorderDetails.map(r => r.prod_id).filter(Boolean);
if (new Set(ids).size !== ids.length) {
  setSuccessMessage("Error: Same product multiple times added");
  submitLock.current = false;
  setSaving(false);
  return;
}

    const salesData = {
      ...data,
      customer_id: selectedEntry.customer_id,
      unit_id, short_code,
      modified_at: currentTime,
      modified_by: data.sales_order_id ? userInfo.user_id : null,
      created_at: currentTime,
      created_by: data.sales_order_id ? salesOrderData?.created_by : userInfo.user_id,
      table_details: JSON.stringify(salesorderDetails),
      changedUpdatedValue: data.sales_order_id ? "edit" : "new",
    };

    try {
      if (data.sales_order_id) {
        await sales_order.editDeletesalesorder(salesData);
      } else {
        await sales_order.addsalesorder(salesData);
      }
      setSuccessMessage(data.sales_order_id ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate('/salesEntries/list-so'), 500);
  } catch (err) {
  setSuccessMessage("Error: " + (err.message || "Unknown error"));
  submitLock.current = false;
  setSaving(false);
}
  };

  const isTableLocked = !!(data.customer_name && data.po_no && salesOrder.length > 0);

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Snackbar */}
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(_, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          Dashboard / Sales Entries /{" "}
          <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Sales Order</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <DescriptionIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData?.sales_order_id ? "UPDATE" : "ADD"} SALES ORDER ENTRIES
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        {/* Main Card */}
        <Box sx={formCardSx}>

          {/* Navy Header */}
          <Box sx={sectionHeaderSx}>
            <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
            <Typography sx={sectionTitleSx}>Sales Order Details</Typography>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={formBodySx}>

              {/* ── Section: Order Info ── */}
              {/* <Typography sx={sectionDividerSx}>Order Information</Typography> */}

              <Grid container spacing={2} sx={{ mb: 2.5 }}>

                {/* Left col — Customer + Sales Officer */}
                <Grid item xs={12} md={6}>
                  <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                      <Typography sx={fieldLabelSx}>
                        Customer Name <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={filteredCustomersWithPo}
                        getOptionLabel={(o) => o.customer_name || ''}
                        value={filteredCustomersWithPo.find(c => c.customer_name === data.customer_name) || null}
                        onChange={(_, newVal) => handleChange({ target: { name: 'customer_name', value: newVal?.customer_name || '' } })}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.customer_name}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={filteredCustomersWithPo.length ? "Select customer" : "No customers with PO"}
                            size="small"
                            sx={inputSx}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography sx={fieldLabelSx}>Sales Officer</Typography>
                      <Autocomplete
                        options={filteredSalesOfficers}
                        getOptionLabel={(o) => `${o.sales_officer_name} (${o.sales_officer_id})` || ''}
                        value={filteredSalesOfficers.find(o => o.sales_officer_id === data.sales_officer_id) || null}
                        onChange={(_, newVal) => handleChange({ target: { name: 'sales_officer_id', value: newVal?.sales_officer_id || '' } })}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={{ fontSize: "13px" }}>
                            {`${option.sales_officer_name} (${option.sales_officer_id})`}
                          </MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={filteredSalesOfficers.length ? "Select sales officer" : "No officers available"}
                            size="small"
                            sx={inputSx}
                          />
                        )}
                        disabled={!filteredSalesOfficers.length}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Right col — SO No / Date / PO No / Date */}
                <Grid item xs={12} md={6}>
                  <Grid container spacing={1.5}>
                    <Grid item xs={6}>
                      <Typography sx={fieldLabelSx}>SO No</Typography>
                      <TextField
                        size="small" fullWidth
                        name="so_no" value={data.so_no}
                        placeholder="Auto-generated"
                        InputProps={{ readOnly: true }}
                        sx={readonlyInputSx}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={fieldLabelSx}>SO Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.so_date ? dayjs(data.so_date) : dayjs()}
                        onChange={(v) => handleChange({ target: { name: "so_date", value: v ? v.format("YYYY-MM-DD") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: datePickerSx } }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={fieldLabelSx}>PO No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <Autocomplete
                        options={filteredPoList}
                        getOptionLabel={(o) => o.po_no || ''}
                        value={filteredPoList.find(c => c.po_no === data.po_no) || null}
                        onChange={(_, newVal) => handleChange({ target: { name: 'po_no', value: newVal?.po_no || '' } })}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.po_no}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={filteredPoList.length ? "Select PO number" : "No POs available"}
                            size="small" sx={inputSx}
                          />
                        )}
                        disabled={!filteredPoList.length}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={fieldLabelSx}>PO Date</Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.po_date ? dayjs(data.po_date, "DD/MM/YYYY") : null}
                        onChange={(v) => handleChange({ target: { name: "po_date", value: v ? v.format("DD/MM/YYYY") : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, sx: datePickerSx } }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* ── Section: Product Details ── */}
              {/* <Typography sx={sectionDividerSx}>Product Details</Typography> */}

              <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>
                <TableContainer>
                  <Table size="small" stickyHeader sx={{ minWidth: 900 }}>
                    <TableHead sx={tableHeadSx}>
                      <TableRow>
                        {["Sr No", "Product Code", "Product Description", "PO Qty",
                          "Delivery Qty", "Balance Qty", "Plan Qty", "Max Holding",
                          "Current Holding", "Action"].map((col) => (
                          <TableCell
                            key={col}
                            align={["Sr No", "Action"].includes(col) ? "center" : "left"}
                            sx={{
                              background: "#1C3A5E", color: "#fff", fontSize: "11px",
                              fontWeight: 600, whiteSpace: "nowrap", borderBottom: "none",
                              width: col === "Sr No" ? 50 : col === "Action" ? 80 : "auto"
                            }}
                          >
                            {col}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {salesorderDetails.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            background: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { background: "#EBF4FF" },
                            "& td": { borderBottom: "1px solid #E2E8F0", padding: "6px 8px" }
                          }}
                        >
                          <TableCell align="center" sx={{ color: "#555", fontWeight: 600, fontSize: "12px" }}>
                            {index + 1}
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="prod_code" value={row.prod_code || ''}
                              onChange={(e) => handleChangeInput(e, index)}
                              disabled={isTableLocked} placeholder="—" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="prod_description" value={row.prod_description || ''}
                              disabled placeholder="—" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="qty_kg" value={row.qty_kg || ''}
                              onChange={(e) => handleChangeInput(e, index)}
                              disabled={isTableLocked} placeholder="0" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="Del_qty" value={row.Del_qty || ''}
                              onChange={(e) => handleChangeInput(e, index)} placeholder="0" />
                          </TableCell>
                          <TableCell>
                            <input style={{ ...tableCellInputSx, color: "#999" }} name="bal_qty"
                              value={row.bal_qty || ''} disabled placeholder="0" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="plan_qty" value={row.plan_qty || ''}
                              onChange={(e) => handleChangeInput(e, index)} placeholder="0" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="max_holding" value={row.max_holding || ''}
                              onChange={(e) => handleChangeInput(e, index)}
                              disabled={isTableLocked} placeholder="0" />
                          </TableCell>
                          <TableCell>
                            <input style={tableCellInputSx} name="curr_hold" value={row.curr_hold || ''}
                              onChange={(e) => handleChangeInput(e, index)} placeholder="0" />
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                              <IconButton size="small" onClick={handleAddRow}
                                sx={{ border: "1px solid #1b52d1", borderRadius: "50%", width: 22, height: 22, color: "#1b52d1" }}>
                                <AddIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                              <IconButton size="small" onClick={() => handleRemoveRow(index)}
                                sx={{ color: "#E53E3E" }}>
                                <DeleteForeverIcon sx={{ fontSize: 18 }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

            </Box>

            {/* Footer Buttons */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>
                Cancel
              </Button>
<Button type="submit" sx={saveBtnSx} disabled={saving}>
  <SaveIcon sx={{ fontSize: 17 }} />
  {saving ? "Saving..." : (editData?.sales_order_id ? "Update" : "Save")}
</Button>
            </Box>
          </form>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default Addsalesorder;